import {ProdType} from '$share/constants/card'
import {CardOrg, MyDataCard} from '$share/types/card/common'
import {Payment} from '$share/types/card/payments'
import {AssetType, CommonDate} from '$share/types/common'

export interface BillDetail {
    id: number // 결제 상세 ID
    cid: MyDataCard['seqno'] // 카드식별자
    paidAt: string // 사용일시
    transNo: string | null // (nullable)해당일자의 거래 특정 번호
    paidAmt: number // 이용금액
    currencyCode: string // 통화코드
    merchantName: string | null // (nullable)가맹점명
    merchantRegno: string | null // (nullable)가맹점사업자등록번호
    creditFeeAmt: number // 신용판매 수수료
    totalInstallCnt: number | null // (nullable) 전체할부회차
    curInstallCnt: number | null // (nullable) 현재할부회차
    balanceAmt: number | null // (nullable) 할부 결제후 잔액
    prodType: ProdType // 카드 상품구분
    billAmt: number | null // (nullable) 청구금액 (이용금액 + 수수료)
    estimatedAmt: number // 할부 및 리볼빙 에 대한 추정 이용금액
}

export interface Bill {
    id: number // CardBill ID
    org: CardOrg
    seqno: string | null // (nullable)결제순번. 복수개의 청구내역의 경우
    chargeDate: CommonDate // 결제예정일 (YYYY-MM-DD)
    chargeAmt: number // 청구금액
    paidOutDate: CommonDate // 출금일
    detailCnt: number // 상세내역의 개수
    linkedBankCode: string | null // (nullable) 결제 은행 코드
    linkedAccNum: string | null // (nullable) 결제계좌의 계좌번호
    linkedAccType: AssetType.DEPOSIT | AssetType.INVEST | null // (nullable) 결제계좌 종류 (deposit, invest)
    linkedAccId: number | null // (nullable) 결제계좌 AssetId
    billDetails: BillDetail[] // 결제 상세
    createAt: string // 생성시각
    updateAt: string // 수정시각
}

export type UniBill = Payment | Bill

export interface UniBillItem {
    id: number
    org: CardOrg
    seqno: string | null
    billFixed: boolean
    isRecentBill: boolean
    dDayLabel: string | undefined
    revolving: boolean
    price: number
    date: string
    expired: boolean
}

export const isBillType = (uniBill: UniBill): uniBill is Bill => {
    return !('payDueDate' in uniBill)
}

export interface UniBillItemPerDate {
    date: string
    price: number
    list: UniBillItem[]
    expired: boolean
}
